import type { SeoFaqItem } from "./seo.types";

export function faqJsonLd(items: SeoFaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((i) => ({
      "@type": "Question",
      name: i.q,
      acceptedAnswer: { "@type": "Answer", text: i.a },
    })),
  };
}

export function breadcrumbJsonLd(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
}

export function serviceJsonLd(name: string, description: string, url: string, areaServed?: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    provider: { "@type": "Organization", name: "Event Sverige" },
    areaServed: areaServed ?? "Sverige",
    url,
  };
}

export function localBusinessJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Event Sverige",
    url: "https://eventsverige.se",
    email: "info@eventsverige.se",
    telephone: "+46317975599",
    address: {
      "@type": "PostalAddress",
      addressCountry: "SE",
    },
    areaServed: "Sverige",
  };
}

export function productJsonLd(p: {
  name: string;
  description?: string;
  image?: string | string[];
  url: string;
  sku?: string;
  category?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: p.name,
    ...(p.description ? { description: p.description } : {}),
    ...(p.image ? { image: p.image } : {}),
    ...(p.sku ? { sku: p.sku, mpn: p.sku } : {}),
    ...(p.category ? { category: p.category } : {}),
    brand: { "@type": "Brand", name: "Event Sverige" },
    offers: {
      "@type": "Offer",
      url: p.url,
      priceCurrency: "SEK",
      priceSpecification: {
        "@type": "PriceSpecification",
        priceCurrency: "SEK",
        description: "Pris enligt offert",
      },
      seller: { "@type": "Organization", name: "Event Sverige" },
    },
  };
}
